module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAABjCAYAAACWsFAzAAAAAXNSR0IArs4c6QAAARtJREFUWAntmUEOAUEQRSfYWVi5gMSOM3ABJ7CxsHEKV3MUliwsJVb8PxlJ13SNEix68Sv5dFX/mnTe9IjOVFVp0U8WtMB4A12hC/Qu5pjcNYZT27hH4QGt2xNOTg+97Kmj9xr8+q0LxQTFSIxiArFD+0iMYgKxQ/tIjGICsUP7SIxiArGjvH2UrnmMZAaN0mLHmB562aP4gsAQPSto8EEvPfSyJ4stKjzxLLOZvEAPvezJ4m8ryq6sQk0gPRzzuZlA90a1oeODz9oU4p27tT086HJCh2NLpryfWq3I3iEvEyOPiq2JkeXhZWLkUbE1MbI8vEyMPCq2JkaWh5eJkUfF1spjlP5h51qP0AGK3mbBUp2hA5S9zUKtgHgCIlkatG5tPxYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/beto.png
// module id = 2RjY
// module chunks = 1